import { useDataValue, useDataChange } from 'Simple/Data.js'
import {
  getUpdatedPayorConfiguration,
  getPayorForDiscount,
  getPercentage,
  changeInsurancesEstimatedReimbursementAmount,
  changePayorsShare,
  changeDiscountsAppliedToPayorsShare,
  changePayorsConfiguration,
  DISCOUNT_TYPE,
} from 'Data/payment-plan.js'

export function useOnChange(props) {
  let types = useDataValue({
    context: 'discount_types',
    viewPath: props.viewPath,
  })
  let treatment_plan = useDataValue({
    context: 'treatment_plan',
    viewPath: props.viewPath,
  })
  let index = useDataValue({
    context: 'discount_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'payment_plan',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      let discount = next.discounts[index]

      if (value) {
        let type = types.find(item => item.id === value)

        discount.type_id = type.id
        discount.name = type.name

        let base
        if (discount.is_applied_to_payor) {
          let payor = getPayorForDiscount(discount, next)
          base = payor.share.amount
        } else {
          base = next.treatment_fee
        }

        if (type.default_amount) {
          discount.type = DISCOUNT_TYPE.FIXED
          discount.amount = type.default_amount
          // dynamically calculate the equivalent percentage for the given amount
          discount.percentage = getPercentage(type.default_amount, base)
        } else {
          discount.type = DISCOUNT_TYPE.PERCENTAGE
          discount.percentage = type.default_percentage
          discount.amount = parseFloat(
            (base * (type.default_percentage / 100)).toFixed(2)
          )
        }

        // recalculate dependant values
        if (discount.is_applied_to_payor) {
          let payor = getPayorForDiscount(discount, next)
          let { downpayment_amount, installment_amount, payment_plan_length } =
            getUpdatedPayorConfiguration(payor, next)
          payor.downpayment_amount = downpayment_amount
          payor.installment_amount = installment_amount
          payor.payment_plan_length = payment_plan_length
        } else {
          discount.is_included_in_insurance_claim =
            type.is_included_in_insurance_claim

          changeInsurancesEstimatedReimbursementAmount(next, treatment_plan)
          changePayorsShare(next)
          changeDiscountsAppliedToPayorsShare(next)
          changePayorsConfiguration(next)
        }
      } else {
        // allow unselecting discount
        discount.type_id = null
        discount.name = ''
      }
    })
  }
}
